const SENSITIVE_KEYS = new Set([
  'token',
  'idtoken',
  'id_token',
  'jointoken',
  'claimtoken',
  'code',
  'credential',
  'access_token',
  'q',
  'query',
  'email'
]);

/** Path plus query keys, with token, search, and email values redacted. Drops the fragment. */
export function sanitizeRoute(raw: string): string {
  const withoutHash = raw.split('#')[0] ?? '';
  const question = withoutHash.indexOf('?');
  if (question < 0) return withoutHash;

  const path = withoutHash.slice(0, question);
  const pairs = withoutHash
    .slice(question + 1)
    .split('&')
    .filter(Boolean)
    .map((pair) => {
      const key = safeDecode(pair.split('=')[0] ?? '');
      return SENSITIVE_KEYS.has(key.toLowerCase()) ? `${key}=[redacted]` : pair;
    });
  return pairs.length ? `${path}?${pairs.join('&')}` : path;
}

function safeDecode(value: string): string {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
}
